import { useAppSelector } from "../app/hooks";
import {
  normalizePositiveInteger,
  resolveAuthCompanyId,
  resolveAuthEmployeeId,
  resolveAuthPermissionId,
} from "../features/auth/authUtils";

export const useAuth = () => {
  const {
    user,
    loading,
    error,
    token,
    roleName,
    roleId,
    userName,
    userId,
    employeeId,
    companyId,
    permissionId,
  } = useAppSelector((state) => state.auth);
  const resolvedCompanyId = resolveAuthCompanyId(companyId, user);
  const resolvedEmployeeId =
    normalizePositiveInteger(employeeId) ??
    normalizePositiveInteger(userId) ??
    resolveAuthEmployeeId(user);
  // Re-derive from the user on every render so a typo'd field name from the
  // backend (e.g. `Permissionid`) still surfaces correctly even before the
  // slice has been re-hydrated by a re-login. The slice value wins when both
  // are present so explicit re-hydrations aren't overridden.
  const resolvedPermissionId = resolveAuthPermissionId(user);

  return {
    user,
    loading,
    error,
    isAuthenticated: Boolean(token),
    token,
    roleName,
    roleId,
    userName,
    userId,
    employeeId: resolvedEmployeeId,
    companyId: resolvedCompanyId,
    permissionId:
      typeof permissionId === "number" && Number.isFinite(permissionId)
        ? permissionId
        : resolvedPermissionId,
  };
};